// src/components/auth/AuthAlert.tsx
import React from "react";

export default function AuthAlert({ message }: { message: string }) {
  if (!message) return null;

  const isSuccess =
    message.toLowerCase().includes("compte cree") ||
    message.toLowerCase().includes("succes");

  return (
    <div
      style={{
        padding: "14px 16px",
        marginBottom: "20px",
        border: `1px solid ${isSuccess ? "#bbf7d0" : "#fecaca"}`,
        borderRadius: "8px",
        color: isSuccess ? "#166534" : "#991b1b",
        backgroundColor: isSuccess ? "#f0fdf4" : "#fef2f2",
        alignItems: "center",
        textAlign: "center",
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: 1.45,
      }}
      role="alert"
    >
      {message}
    </div>
  );
}
